export const sharedStrings = {
  shipmentMode: {
    ltl: "LTL",
    ftl: "FTL",
    threepl: "3PL",
  },
  shipmentStatus: {
    quotedTitle: "Quoted",
    quotedLower: "quoted",
    bookedLower: "booked",
    processing: "Processing",
    failed: "Failed",
  },
  actions: {
    confirmYes: "Yes",
    confirmNo: "No",
  },
} as const;
